/*

Optionsauswahl mit Radiobutton, Name, Beschreibung, Info-Icon mit Tooltip-Fenster

(x) Erste Option (i)
    Lorem Ipsum dolor sit Amet

( ) Zweite Option (i)
    Consectetur adipiscing elit

( ) Dritte Option (i)
    Maecenas semper, magna

*/

import './RadioLines.css'

function RadioLines({name, options, selected, onChange}) {

    return (
        <ul className="radioLines" key={name}>
            {Object.keys(options).map((option, i) => (
                <li key={options[option].key}>
                    <label>
                        <input type="radio" name={name} value={options[option].key} checked={selected === options[option].key} className="option" onChange={e => onChange(e.target.name, e.target.value)} />
                        <div className="name">
                            {options[option].name}
                            {options[option].info ?
                                <div className='info'>
                                    <i className='fa fa-info-circle'></i>
                                    <div className='tooltip' dangerouslySetInnerHTML={{__html: options[option].info}}></div>
                                </div>
                            : '' }
                        </div>
                        <div className="description">{options[option].description}</div>
                    </label>
                </li>
            ))}
        </ul>
    )

}

export default RadioLines
